import React from 'react';
import { Badge } from 'react-bootstrap';
import Tooltip from '../tooltip/Tooltip';

/**
 * Small badge with optional react-icons JSX icon.
 *
 * @param {string} text Text inside the badge
 * @param {string} color Bootstrap color variant (e.g., 'primary', 'danger')
 * @param {string} bg Optional background override (default: light-{color})
 * @param {JSX.Element} icon React Icon component (example: <FaCheckCircle />)
 * @param {boolean} onlyIcon If true, show only the icon (no text)
 * @param {string} className Additional classes
 * @returns {JSX.Element}
 */
const TinyBadge = ({
  text,
  color = 'primary',
  bg = `light-${color}`,
  icon,
  onlyIcon = false,
  className = '',
}) => {
  return (
    <Tooltip tooltip={text}>

      <Badge
        bg={bg}
        text={color}
        className={ `small ${ !onlyIcon && "rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"} ${className}`}
      >
        {icon && <span className="d-flex align-items-center">{icon}</span>}
        {!onlyIcon && <span>{text}</span>}
      </Badge>
    </Tooltip>
  );
};

export default TinyBadge;
